import Fuse from 'fuse.js';

// Maintain separate Fuse indexes per search type (e.g., 'cpt', 'icd')
const indexes = new Map();

export function initializeSearch(type, dataArray) {
  if (!Array.isArray(dataArray) || dataArray.length === 0) {
    indexes.delete(type);
    return;
  }
  const options = {
    includeScore: true,
    shouldSort: true,
    threshold: 0.35,
    ignoreLocation: true,
    minMatchCharLength: 1,
    keys: [
      { name: 'code', weight: 0.7 },
      { name: 'description', weight: 0.3 },
    ],
  };
  const fuse = new Fuse(dataArray, options);
  indexes.set(type, fuse);
}

export function performSearch(type, query, opts = {}) {
  const { limit = 200 } = opts;
  if (!query || !query.trim()) return [];
  const fuse = indexes.get(type);
  if (fuse) {
    return fuse.search(query).slice(0, limit).map(r => r.item);
  }
  // Fallback: basic filter requires the caller to supply data; here we cannot, so empty
  return [];
}

export function getSearchSuggestions(type, query, limit = 8) {
  const fuse = indexes.get(type);
  if (!fuse || !query || !query.trim()) return [];
  const results = fuse.search(query).slice(0, limit).map(r => r.item);
  // Return a simple list of strings for suggestions: prefer code then description
  return results.map(item => `${item.code} — ${item.description}`);
}

